import axios from "axios";
import router from ".././router";
import {
    Message
} from "element-ui";

axios.defaults.baseURL = process.env.VUE_APP_REQUEST_URL;

axios.defaults.timeout = 30000; //设置请求超时
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8"; //设置post请求头

// 请求拦截
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("adminToken");
        if (token) {
            if (Object.prototype.toString.call(config.data) == '[object FormData]') {
                config.data.append("token", token);
            } else {
                let data = JSON.parse(config.data)
                config.data = JSON.stringify({
                    token: token,
                    ...data
                })
            }
        }
        return config;
    },
    (error) => {
        return Promise.error(error);
    }
);
// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        if (response.status === 200) {
            if (response.data.code) {
                if (response.data.code == '1015') {
                    Message.error("登录超时！请重新登录");
                    setTimeout(() => {
                        router.replace({
                            path: "/login",
                            query: {
                                redirect: router.currentRoute.fullPath,
                            },
                        });
                    }, 1000);
                } else if (response.data.code == '1901') {
                    // Message.error(response.data.message);
                } else if (response.data.code == '1004') {
                    Message.error(response.data.message);
                    return Promise.reject(response);
                    // setTimeout(() => {
                    //     router.go(-1);
                    // }, 1000);
                } else if (response.data.code != '0') {
                    Message.error(response.data.message);
                    return Promise.reject(response);
                }
            }
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 根据返回的状态码进行相关操作，例如登录过期提示，错误提示等等
    (error) => {

        return Promise.reject(error);
    }
);
/**
 * post方法，对应post请求
 * @param {String} url [请求地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {

    return new Promise((resolve, reject) => {
        axios
            .post(url, JSON.stringify(params))
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}
/**
 * post方法，对应post请求（超时时间10分钟）
 * @param {String} url [请求地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postLong(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, JSON.stringify(params), {
                timeout: 600000
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}
//文件上传（超时时间10分钟）
//批量上传账户且查询天眼查的场景会耗时比较久，其他场景估计2分钟左右就行了
export function postUpload(url, params) {

    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                timeout: 600000
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}
/**
 * 表格下载downFile方法，对应downFile请求（超时时间10分钟）
 * @param {String} url [请求地址]
 * @param {Object} params [请求时携带的参数]
 */
export function downFile(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, JSON.stringify(params), {
                timeout: 600000,
                responseType: "blob"
            })
            .then((res) => {
                // 后台返回错误
                if (res.data.type == 'application/json') {

                    let typeCount = {
                        type: "application/octet-stream",
                    };
                    let blob = new Blob([res.data], typeCount);

                    const fileReader = new FileReader();
                    fileReader.readAsText(blob, 'utf-8');

                    fileReader.onload = function () {
                        let message = JSON.parse(fileReader.result);
                        Message.error(message.message);
                    }


                    reject(res.data);
                } else {
                    // 有文件下载
                    resolve(res.data);
                    let downloadA = document.createElement('a');
                    let blob = new Blob([res.data], {
                        type: res.headers['content-type']
                    });
                    downloadA.href = URL.createObjectURL(blob);
                    if (res.headers['content-disposition']) {
                        let cd = res.headers['content-disposition'];
                        if (cd.lastIndexOf("filename=")) {
                            let fileName = cd.substr(cd.lastIndexOf("filename=") + 9);
                            if (fileName) {
                                downloadA.download = fileName;
                            }
                        }
                    }
                    downloadA.click();
                    URL.revokeObjectURL(downloadA.href);
                }
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}